import React from "react";
import { ChartPie, CircleAlert, ShieldMinus, ShieldCheck } from "lucide-react";
import {
	BreakdownItem,
	BreakdownRow,
	Card,
	CardHeader,
	CardLabel,
	CardValue,
	CardsRow,
	IconWrapper
} from "./styles";

const DEFAULT_METRICS = {
	totalProviders: 0,
	lifeInsurance: { active: 0, pending: 0 },
	dit: { active: 0, pending: 0 },
	triggers: 0
};

const BigNumbers = ({ metrics, loading = false }) => {
	const values = {
		...DEFAULT_METRICS,
		...metrics,
		lifeInsurance: { ...DEFAULT_METRICS.lifeInsurance, ...metrics?.lifeInsurance },
		dit: { ...DEFAULT_METRICS.dit, ...metrics?.dit }
	};
	const cards = [
		{
			label: "Total prestadores",
			icon: <ChartPie size={20} />,
			color: "#ef7b49",
			value: values.totalProviders
		},
		{
			label: "Seguro Vida",
			icon: <ShieldCheck size={20} />,
			color: "#159f72",
			breakdown: [
				{ label: "Ativos", value: values.lifeInsurance.active, color: "#159f72" },
				{
					label: "Pendentes",
					value: values.lifeInsurance.pending,
					color: "#d3cf00"
				}
			]
		},
		{
			label: "DIT",
			icon: <ShieldMinus size={20} />,
			color: "#504c9a",
			breakdown: [
				{ label: "Ativos", value: values.dit.active, color: "#159f72" },
				{ label: "Pendentes", value: values.dit.pending, color: "#d3cf00" }
			]
		},
		{
			label: "Acionamentos",
			icon: <CircleAlert size={20} />,
			color: "#bcb91b",
			value: values.triggers
		}
	];

	return (
		<CardsRow aria-busy={loading}>
			{cards.map(card => (
				<Card key={card.label} loading={loading}>
					<CardHeader>
						<IconWrapper color={card.color}>{card.icon}</IconWrapper>
						<CardLabel>{card.label}</CardLabel>
					</CardHeader>

					{card.breakdown ? (
						<BreakdownRow>
							{card.breakdown.map(item => (
								<BreakdownItem key={item.label} color={item.color}>
									<strong>{item.value}</strong> {item.label}
								</BreakdownItem>
							))}
						</BreakdownRow>
					) : (
						<CardValue>{card.value}</CardValue>
					)}
				</Card>
			))}
		</CardsRow>
	);
};

export default BigNumbers;
